import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  POST_GetTestMethodsDetailByID,
  POST_GetTestMethodsReviseHistList,
  POST_TestMethodsReviseInsert,
} from "../../../helpers/url_helper";
import { SVGICON } from "../../../constant/theme";
import {
  capitalizeString,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";

const ReviseTestMethod = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const [testMethodRefDocFile, setTestMethodRefDocFile] = useState(null);

  const [showReviseHistoryModal, setShowReviseHistoryModal] = useState(false);
  const [showReviseHistDetailModal, setShowReviseHistDetailModal] =
    useState(false);

  const [listOfTestMethodReviseHist, setListOfTestMethodReviseHist] = useState(
    [],
  );

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    TestMethodCodeType: Yup.number(),
    TestMethod: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 2)
          return Yup.string()
            .trim()
            .required("Test Method Name is required field");
        return schema;
      },
    ),
    TestMethodCountryCode: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 1)
          return Yup.string().trim().required("Country Code is required field");
        return schema;
      },
    ),
    StandardCode: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 1)
          return Yup.string()
            .trim()
            .required("Standard Code is required field");
        return schema;
      },
    ),
    Delimiter: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 1)
          return Yup.string().trim().required("Delimiter is required field");
        return schema;
      },
    ),
    MethodYear: Yup.string().when(
      "TestMethodCodeType",
      ([TestMethodCodeType], schema) => {
        if (TestMethodCodeType == 1)
          return Yup.string().trim().required("Year is required field");
        return schema;
      },
    ),
    DisplayName: Yup.string().trim().required("Display Name is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      TestMethodIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      TestMethodCodeType: 1,
      TestMethod: "",
      OldTestMethodName: "",
      TestMethodCountryCode: "",
      StandardCode: "",
      Delimiter: "",
      MethodYear: "",
      Description: "",
      IsNABL: false,
      IsVerified: true,
      VerificationValidityDate: "",
      TestMethodRefDocFilePath: "",
      TestMethodRefDocFilePathURL: "",
      ListOfTestMapped: [],
      ListOfElementMapped: [],
      VerificationDoneBy: "",
      VerificationDoneByName: "",
      VerificationDateTime: "",
      ParentTestMethoIDEncrypt: "",
      //ListOfTestMethodReviseHist: [],
      ListOfTestMasterTestMethodDetails: [],
      ListOfTestMasterStandardParametersDetails: [],
      DisplayName: "",
      NickName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      TestMethodCodeType,
      TestMethodCountryCode,
      StandardCode,
      Delimiter,
      MethodYear,
      IsNABL,
      IsVerified,
      VerificationValidityDate,
      TestMethodRefDocFilePath,
      ListOfTestMapped,
      ListOfElementMapped,
      VerificationDoneBy,
      VerificationDateTime,
      VerificationDoneByName,
      OldTestMethodName,
      ParentTestMethoIDEncrypt,
      //ListOfTestMethodReviseHist,
      ListOfTestMasterTestMethodDetails,
      ListOfTestMasterStandardParametersDetails,
      DisplayName,
      NickName,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (OldTestMethodName.trim() == values.TestMethod.trim()) {
      formik.setFieldError(
        "TestMethod",
        "Test Method Name Not Same to Old Test Method ..!",
      );
      formik.setFieldTouched("TestMethod", true);
      return;
    }

    setIsLoading(true);
    let formData = new FormData();

    formData.append("TestMethodIDEncrypt", values?.TestMethodIDEncrypt);
    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
    formData.append("TestMethod", values?.TestMethod.trim());
    formData.append("TestMethodCodeType", values?.TestMethodCodeType);
    formData.append("DisplayName", values?.DisplayName);
    formData.append("NickName", values?.NickName);

    formData.append(
      "TestMethodCountryCode",
      values?.TestMethodCountryCode ? values?.TestMethodCountryCode.trim() : "",
    );
    formData.append(
      "StandardCode",
      values?.StandardCode ? values?.StandardCode.trim() : "",
    );
    formData.append(
      "Delimiter",
      values?.Delimiter ? values?.Delimiter.trim() : "",
    );
    formData.append(
      "MethodYear",
      values?.MethodYear ? values?.MethodYear.trim() : "",
    );
    formData.append("Description", values?.Description);
    formData.append("IsNABL", values?.IsNABL);
    formData.append(
      "VerificationDoneByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append(
      "TestMethodRefDocFilePathURL",
      values?.TestMethodRefDocFilePathURL,
    );
    formData.append("TestMethodRefDocFilePath", testMethodRefDocFile);
    formData.append(
      "CreatedByEncrypted",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );

    //console.log("Add", formData);

    postFormData(POST_TestMethodsReviseInsert, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/test-method");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (PrimaryIdParam) {
      GetTestMethodsDetailByID(PrimaryIdParam);
      //   post(POST_GetTestMethodsDetailByID, {
      //     TestMethodIDEncrypt: window.atob(PrimaryIdParam),
      //   })
      //     .then((response) => {
      //       if (response?.IsSuccess) {
      //         formik.setValues({
      //           ...response,
      //           TestMethod: response?.TestMethod,
      //           OldTestMethodName: response?.TestMethod,
      //           ParentTestMethoIDEncrypt: response?.ParentTestMethoIDEncrypt,
      //           VerificationValidityDate: response?.VerificationValidityDate,
      //           VerificationDateTime: response?.VerificationDateTime,
      //           VerificationDoneByName: response?.VerificationDoneByName,
      //           ListOfTestMapped: response?.ListOfTestMasterTestMethod,
      //           ListOfElementMapped: response?.ListOfTestMasterStandardParameters,
      //         });
      //       }
      //       //setTestMethod(response?.TestMethod);
      //       setIsLoading(false);
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //       setIsLoading(false);
      //     });
      GetTestMethodsReviseHistList(PrimaryIdParam);
    } else {
      setIsLoading(false);
    }
  }, []);

  const GetTestMethodsDetailByID = async (id) => {
    setIsLoading(true);
    post(POST_GetTestMethodsDetailByID, {
      TestMethodIDEncrypt: window.atob(id),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            TestMethod: response?.TestMethod,
            OldTestMethodName: response?.TestMethod,
            ParentTestMethoIDEncrypt: response?.ParentTestMethoIDEncrypt,
            VerificationValidityDate: response?.VerificationValidityDate,
            VerificationDateTime: response?.VerificationDateTime,
            VerificationDoneByName: response?.VerificationDoneByName,
            ListOfTestMapped: response?.ListOfTestMasterTestMethod,
            ListOfElementMapped: response?.ListOfTestMasterStandardParameters,
          });
        }

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetTestMethodsReviseHistList = async (id) => {
    setIsLoading(true);
    post(POST_GetTestMethodsReviseHistList, {
      TestMethodIDEncrypt: window.atob(id),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // formik.setFieldValue(
          //   "ListOfTestMethodReviseHist",
          //   response?.ListOfTestMethodRevise
          // );
          setListOfTestMethodReviseHist(response?.ListOfTestMethodRevise);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  function createTestMethodName(CountryCode, StandardCode, Delimiter, Year) {
    let name = "";

    if (CountryCode) {
      name += CountryCode.trim() + " ";
    }
    if (StandardCode) {
      name += StandardCode.trim() + " ";
    }
    if (Delimiter) {
      name += Delimiter.trim() + " ";
    }
    if (Year) {
      name += Year.trim();
    }

    formik.setFieldValue("TestMethod", name);
    //setTestMethod(name);
  }

  useEffect(() => {
    if (TestMethodCodeType == 1) {
      createTestMethodName(
        TestMethodCountryCode,
        StandardCode,
        Delimiter,
        MethodYear,
      );
    }
  }, [TestMethodCountryCode, StandardCode, Delimiter, MethodYear]);

  const uploadTestMethodRefDocFile = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /(doc|docx|pdf)$/;

      var validPdfSize = true;
      var validFileFormat = true;

      if (
        !file.type.match("pdf") &&
        !file.type.match("doc") &&
        !file.type.match("docx")
      ) {
        validFileFormat = false;
        setTestMethodRefDocFile(null);

        warningMessage("Select valid Doc/PDF file!");
      } else {
        if (Math.round(file.size / 1024 / 1024) > 20) {
          validPdfSize = false;
        }
      }

      if (validFileFormat && validPdfSize) {
        setTestMethodRefDocFile(file);
      } else {
        e.target.value = [];
        if (!validPdfSize) {
          warningMessage("Doc/Pdf file should not be more than 20 MB!");
          setTestMethodRefDocFile(null);
        }
      }
    }
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Revise Test Method</h4>
                <div className="d-flex align-items-center">
                  <div>
                    <Link
                      to="#"
                      className="text-primary"
                      onClick={() => {
                        setShowReviseHistoryModal(true);
                      }}
                    >
                      View Revise History
                    </Link>
                  </div>
                  &nbsp;&nbsp;&nbsp;
                  {PrimaryIdParam ? (
                    <>
                      <div className="pe-2">
                        {IsVerified ? SVGICON.Verified : SVGICON.Unverified}{" "}
                        {IsVerified ? "Verified" : "Unverified"}
                      </div>
                      <div>
                        {VerificationDoneByName ? (
                          <>
                            {" | "}
                            <span className="fs-12">
                              {VerificationDoneByName} {" - "}
                              {VerificationDateTime}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                        {VerificationDoneByName && VerificationValidityDate
                          ? " | "
                          : ""}
                        {VerificationValidityDate ? (
                          <span className="fs-12">
                            {IsVerified ? "Expiry" : "Expired"} Date -{" "}
                            {VerificationValidityDate}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={7}>
                      <div className="card mb-2" style={{ height: "auto" }}>
                        <div className="card-body p-2">
                          <Row>
                            <Col lg={12}>
                              <label>
                                Name <span className="text-danger">*</span>
                              </label>
                            </Col>
                            <Col lg={12}>
                              <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  id="customRadioStandard"
                                  name="TestMethodCodeType"
                                  title="Standard Name"
                                  style={{ cursor: "pointer" }}
                                  checked={
                                    TestMethodCodeType == 1 ? true : false
                                  }
                                  onChange={() => {
                                    formik.setFieldValue(
                                      "TestMethodCodeType",
                                      1,
                                    );
                                    // formik.setFieldValue("TestMethod", "");
                                  }}
                                  autoFocus
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customRadioStandard"
                                >
                                  Standard Name
                                </label>
                              </div>
                              <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  id="customRadioManual"
                                  name="TestMethodCodeType"
                                  title="Manual"
                                  style={{ cursor: "pointer" }}
                                  checked={
                                    TestMethodCodeType == 2 ? true : false
                                  }
                                  onChange={() => {
                                    formik.setFieldValue(
                                      "TestMethodCodeType",
                                      2,
                                    );
                                    formik.setFieldValue(
                                      "TestMethodCountryCode",
                                      "",
                                    );
                                    formik.setFieldValue("StandardCode", "");
                                    formik.setFieldValue("Delimiter", "");
                                    formik.setFieldValue("MethodYear", "");
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customRadioManual"
                                >
                                  Manual
                                </label>
                              </div>
                            </Col>
                            {TestMethodCodeType == 1 ? (
                              <Col lg={12}>
                                <Row>
                                  <Col lg={4} className="pe-zero">
                                    <Field
                                      label="Country Code"
                                      name="TestMethodCountryCode"
                                      placeholder={"Enter Country Code"}
                                      component={CustomInput}
                                      required
                                      maxLength={25}
                                      disabled={
                                        TestMethodCodeType == 2 ? true : false
                                      }
                                    />
                                  </Col>
                                  <Col lg={4} className="pe-zero">
                                    <Field
                                      label="Standard Code"
                                      name="StandardCode"
                                      placeholder={"Enter Standard Code"}
                                      component={CustomInput}
                                      required
                                      maxLength={100}
                                      disabled={
                                        TestMethodCodeType == 2 ? true : false
                                      }
                                    />
                                  </Col>
                                  <Col lg={2} className="pe-zero">
                                    <Field
                                      label="Delimiter"
                                      name="Delimiter"
                                      placeholder={"Delimiter"}
                                      component={CustomInput}
                                      required
                                      maxLength={5}
                                      disabled={
                                        TestMethodCodeType == 2 ? true : false
                                      }
                                    />
                                  </Col>
                                  <Col lg={2}>
                                    <Field
                                      label="Year"
                                      name="MethodYear"
                                      placeholder={"Year"}
                                      component={CustomInput}
                                      required
                                      maxLength={4}
                                      disabled={
                                        TestMethodCodeType == 2 ? true : false
                                      }
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            ) : (
                              ""
                            )}
                            <Col lg={12}>
                              <Field
                                name="TestMethod"
                                placeholder={"Enter Test Method Name"}
                                component={CustomInput}
                                required
                                maxLength={100}
                                disabled={
                                  TestMethodCodeType == 1 ? true : false
                                }
                              />
                            </Col>
                            <Col lg={12}>
                              <Field
                                label="Display Name"
                                name="DisplayName"
                                placeholder={"Enter Display Name"}
                                component={CustomInput}
                                required
                                maxLength={500}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "DisplayName",
                                    capitalizeString(e?.target?.value),
                                  );
                                }}
                              />
                            </Col>
                            <Col lg={12}>
                              <Field
                                label="Nick Name"
                                name="NickName"
                                placeholder={"Enter Nick Name"}
                                component={CustomInput}
                                maxLength={500}
                              />
                            </Col>
                            <Col lg={12}>
                              <Field
                                label="Description"
                                name="Description"
                                placeholder={"Enter Description"}
                                component={CustomTextArea}
                                rows={3}
                                maxLength={2000}
                              />
                            </Col>
                            <Col lg={12}>
                              <div className="d-flex mb-2">
                                <label className="mb-1">NABL &nbsp;</label>
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckChecked"
                                    title={IsNABL == true ? "Yes" : "No"}
                                    checked={IsNABL}
                                    onChange={() => {
                                      formik.setFieldValue("IsNABL", !IsNABL);
                                    }}
                                  ></input>
                                </div>
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="d-flex justify-content-between">
                                <label className="mb-1">
                                  Test Method Ref. Doc File{" "}
                                </label>
                              </div>
                              <input
                                type="file"
                                id="fileUpload"
                                className="form-control form-control-sm"
                                accept=".doc,.docx,application/pdf"
                                onChange={uploadTestMethodRefDocFile}
                              />
                              <label htmlFor="fileUpload" name=""></label>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Col>
                    {PrimaryIdParam &&
                    (AuthUser?.Permissions?.DT == 1 ||
                      AuthUser?.Permissions?.FoodTesting == 1) ? (
                      <Col lg={5}>
                        <Row>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-header p-2 ps-3 pb-0">
                                <label>Mapped Test</label>
                              </div>
                              <div className="card-body fs-14 pt-1 pb-2">
                                {ListOfTestMapped?.length > 0 ? (
                                  <ul className="unorder-list ps-3">
                                    {ListOfTestMapped?.map((item, indx) => (
                                      <li key={indx}>{item.TestName}</li>
                                    ))}
                                  </ul>
                                ) : (
                                  <span className="fs-12">
                                    No data found...
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <div
                              className="card mb-2"
                              style={{ height: "auto" }}
                            >
                              <div className="card-header p-2 ps-3 pb-0">
                                <label>Mapped Element</label>
                              </div>
                              <div className="card-body fs-14 pt-1 pb-2">
                                {ListOfElementMapped?.length > 0 ? (
                                  <ul className="unorder-list ps-3">
                                    {ListOfElementMapped?.map((item, indx) => (
                                      <li key={indx}>
                                        {item.ParameterHeaderDisplayName}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <span className="fs-12">
                                    No data found...
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm me-2"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>

      <Modal
        className="fade"
        show={showReviseHistoryModal}
        onHide={setShowReviseHistoryModal}
        size="xl"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title> Test Method Revise History</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowReviseHistoryModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className="table-responsive active-projects style-1 shorting mb-2">
                  <div
                    id="ReviseHistory-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="ReviseHistory-tbl"
                      className="table dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <th width="45%">Test Method</th>
                          <th width="15%">Validity Date</th>
                          <th width="15%">Effective Date</th>
                          <th width="10%">NABL</th>
                          <th width="5%">File</th>
                          <th width="5%" style={{ textAlign: "left" }}>
                            Mapped
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {listOfTestMethodReviseHist?.length > 0 ? (
                          listOfTestMethodReviseHist?.map((item, indx) => (
                            <tr key={indx}>
                              <td>{indx + 1}</td>
                              <td>{item?.TestMethod}</td>
                              <td>{item?.VerificationValidityDate}</td>
                              <td>{item?.EffectiveDate}</td>
                              <td>{item?.IsNABL ? "Yes" : "No"}</td>
                              <td>
                                {item?.TestMethodRefDocFilePath ? (
                                  <Link
                                    to="#"
                                    className="fs-14"
                                    title="Download"
                                    onClick={() => {
                                      window.open(
                                        item?.TestMethodRefDocFilePath,
                                        "_blank",
                                      );
                                    }}
                                  >
                                    {SVGICON.Download}
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td style={{ textAlign: "left" }}>
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="View Mapped Detail"
                                  onClick={() => {
                                    setShowReviseHistDetailModal(true);
                                    formik.setFieldValue(
                                      "ListOfTestMasterTestMethodDetails",
                                      item?.ListOfTestMasterTestMethod,
                                    );
                                    formik.setFieldValue(
                                      "ListOfTestMasterStandardParametersDetails",
                                      item?.ListOfTestMasterStandardParameters,
                                    );
                                  }}
                                >
                                  {SVGICON.NoteText}
                                </Link>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={7} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>

      <Modal
        className="fade"
        show={showReviseHistDetailModal}
        onHide={setShowReviseHistDetailModal}
        size="xl"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <Modal.Header>
            <Modal.Title>Revise History</Modal.Title>
            <Button
              type="button"
              variant=""
              className="btn-close"
              onClick={() => setShowReviseHistDetailModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col lg={6}>
                <div className="card mb-2" style={{ height: "auto" }}>
                  <div className="card-header p-2 ps-3 pb-0">
                    <label>Mapped Test</label>
                  </div>
                  <div className="card-body fs-14 pt-1 pb-2">
                    {ListOfTestMasterTestMethodDetails?.length > 0 ? (
                      <ul className="unorder-list ps-3">
                        {ListOfTestMasterTestMethodDetails?.map(
                          (item, indx) => (
                            <li key={indx}>{item.TestName}</li>
                          ),
                        )}
                      </ul>
                    ) : (
                      <span className="fs-12">No data found...</span>
                    )}
                  </div>
                </div>
              </Col>

              <Col lg={6}>
                <div className="card mb-2" style={{ height: "auto" }}>
                  <div className="card-header p-2 ps-3 pb-0">
                    <label>Mapped Element</label>
                  </div>
                  <div className="card-body fs-14 pt-1 pb-2">
                    {ListOfTestMasterStandardParametersDetails?.length > 0 ? (
                      <ul className="unorder-list ps-3">
                        {ListOfTestMasterStandardParametersDetails?.map(
                          (item, indx) => (
                            <li key={indx}>
                              {item.ParameterHeaderDisplayName}
                            </li>
                          ),
                        )}
                      </ul>
                    ) : (
                      <span className="fs-12">No data found...</span>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Spin>
      </Modal>
    </>
  );
};

export default ReviseTestMethod;
